import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import campaignReducer from './slices/campaignSlice';
import contactReducer from './slices/contactSlice';
import cmsReducer from './slices/cmsSlice';
import blogReducer from './slices/blogSlice';
import monthlyDonationReducer from './slices/monthlyDonationSlice';
import stripeCheckoutReducer from './slices/stripeCheckoutSlice';
import eightyGReducer from './slices/eightyGSlice';
import userTenbeReducer from './slices/userTenbeSlice';
import transactionReducer from './slices/transactionSlice';
import donationReducer from './slices/donationSlice';

const reducers = combineReducers({
  auth: authReducer,
  campaign: campaignReducer,
  contact: contactReducer,
  cms: cmsReducer,
  blog: blogReducer,
  monthlyDonation: monthlyDonationReducer,
  stripeCheckout: stripeCheckoutReducer,
  eightyG: eightyGReducer,
  userTenbe: userTenbeReducer,
  transaction: transactionReducer,
  donation: donationReducer,
});

export default reducers;
